import config from 'utils/config';
export var isHelixAndLearningHub = config.helixIntegrationMode === 'both';